import { Box } from '@chakra-ui/react';
import { Skeleton } from 'components/ds';
import React from 'react';

const SKELETON_OPTIONS = [
  {
    h: '16px',
    w: '25%',
  },
  {
    h: '16px',
    w: '35%',
  },
  {
    h: '16px',
    w: '50%',
  },
  {
    h: '16px',
    w: '50%',
  },
  {
    h: '16px',
    w: '75%',
  },
  {
    h: '16px',
    w: '90%',
  },
  {
    h: '16px',
    w: '100%',
  },
  {
    h: '16px',
    w: '100%',
  },
  {
    h: '16px',
    w: '100%',
  },
];

const AmatriumSkeleton = ({ options }) => {
  const ourOptions = options?.length ? options : SKELETON_OPTIONS;
  return (
    <Box w='100%' h='100%'>
      {ourOptions.map((skeleton, id) => (
        <Skeleton key={id} w={skeleton.w} h={skeleton.h} mb='0.5rem' />
      ))}
    </Box>
  );
};

export default AmatriumSkeleton;
